import React from 'react';

import ProductPrice from './ProductPrice';
import InlineSvg from "../InlineSvg";

import { __ } from "../Translator";
import { roundNumber, thronImageUrl } from "../Helpers";

import ExpandPartsIcon from './../img/price-detail-parts-arrow-down.svg';

import './ProductPriceDetailed.css';
import AppStore from "../flux/AppStore";
import LanguageStore from '../flux/LanguageStore';

import currencySymbol from '../utils/currencySymbol';
import CountryStore from '../flux/CountryStore';
import shouldShowPrice from '../utils/shouldShowPrice';

class ProductPriceDetailed extends ProductPrice {
  static ProductImageWidth = '';
  static ProductImageHeight = 350;

  subscriptions = [];

  constructor(props) {
    super(props);

    this.state = Object.assign({
      customProduct: AppStore.getCustomProduct(),
      partListExpanded: false,
    }, this.state);

    this.onCustomProductChange = this.onCustomProductChange.bind(this);
    this.onCustomProductInit = this.onCustomProductInit.bind(this);
  }

  componentDidMount(){
      AppStore.events.initCustomProduct.addListener(this.onCustomProductInit);
      this.subscriptions.push(LanguageStore.addListener(() => {
          this.forceUpdate();
      }));
  }

  componentWillUnmount(){
      this.subscriptions.forEach(subscription => subscription.remove());
      AppStore.events.initCustomProduct.removeListener(this.onCustomProductInit);
  }

  // @todo 2017-09-26 customized was changed to custom_colored
  render() {
    const flattenedSpecificationWithPrice = this.getFlattenedSpecificationWithPrice();

    const productImage = this.state.customProduct.custom_colored
      ? this.state.customProduct.screenshots.front
      : thronImageUrl(
          this.state.customProduct.color.preview_image_url,
          ProductPriceDetailed.ProductImageWidth,
          ProductPriceDetailed.ProductImageHeight
        );

    const symbol = currencySymbol(this.state.customProduct.product.country_id);

    return (
      <div className="productPriceDetailed">
        <div className="productPriceDetailed__image">
          <img src={productImage} alt=""/>
        </div>

        <div className="productPriceDetailed__detail u-mt-20">
          <h4>
            <strong className="u-tt-uppercase">{this.state.customProduct.product.name}</strong> <br /> {shouldShowPrice(CountryStore.getState()) ?  parseFloat(roundNumber(this.state.customProduct.product.base_price)).toLocaleString(undefined, {minimumFractionDigits: 2}) : ""}  <span className="m--eur">{shouldShowPrice(CountryStore.getState()) ? symbol : ""}</span>
          </h4>
          <hr/>
          {this.state.customProduct.perforated !== null ? (
            <div>
              {this.state.customProduct.perforated
                ? <h4 className="uppercase">{__('Perforated version')}  {shouldShowPrice(CountryStore.getState()) ? "+ "+parseFloat(roundNumber(this.state.customProduct.product.perforated_price)).toLocaleString(undefined, {minimumFractionDigits: 2}) : ""} <span className="m--eur">{shouldShowPrice(CountryStore.getState()) ? symbol : ""}</span></h4>
                : <h4 className="uppercase">{__('Standard version')}  {shouldShowPrice(CountryStore.getState()) ? "+ "+parseFloat(roundNumber(0)).toLocaleString(undefined, {minimumFractionDigits: 2}) : ""} <span className="m--eur">{shouldShowPrice(CountryStore.getState()) ? symbol : ""}</span></h4>}
            </div>
          ) : null}

          {this.state.customProduct.custom_colored !== null ? (
            <div>
              <hr/>
              {this.state.customProduct.custom_colored ? (
                <div className={`partList ${flattenedSpecificationWithPrice.length > 3 ? 'can-expand' : ''} ${this.state.partListExpanded ? 'is-expanded' : ''}`}>
                  <h4 onClick={() => this.setState({ partListExpanded: ! this.state.partListExpanded })}>
                    <InlineSvg className="partList__arrow" svg={ExpandPartsIcon} />
                    <span>
                      <i>{__('Custom design')}</i> {shouldShowPrice(CountryStore.getState()) ?  " + "+parseFloat(roundNumber(this.state.customProduct.product.customization_price)).toLocaleString() : ""} <span className="m--eur">{shouldShowPrice(CountryStore.getState()) ? symbol : ""  }</span>
                    </span>
                  </h4>
                  <div>
                    {flattenedSpecificationWithPrice.map(item => {
                      if(shouldShowPrice(CountryStore.getState())) {
                          return (
                              <h5 key={item.key}>
                                <i>{__(item.key.charAt(0).toUpperCase() + item.key.slice(1))} {['elbow_sliders','knee_sliders','shoulder_plates','knee_plates','elbow_plates'].indexOf(item.key) !== -1 ? '' : __('Add-ons')+ " "}</i>
                                + {parseFloat(roundNumber(item.price)).toLocaleString(undefined, {minimumFractionDigits: 2})} <span
                                  className="m--eur">{symbol}</span>
                              </h5>
                          );
                      }
                    })}
                  </div>
                </div>
              ) : (
                <h4>
                  <i>{__('Standard color')}</i> + {shouldShowPrice(CountryStore.getState()) ? parseFloat(roundNumber(0)).toLocaleString(undefined, {minimumFractionDigits: 2}) : ""} <span className="m--eur">{shouldShowPrice(CountryStore.getState()) ? symbol : ""}</span>
                </h4>
              )}
            </div>
          ) : null}

          {this.state.customProduct.custom_fitted !== null ? (
            <div>
              <hr/>
              {this.state.customProduct.custom_fitted
                ? <span><i>{__('Custom fit')}</i> {shouldShowPrice(CountryStore.getState()) ? " + " + parseFloat(roundNumber(this.state.customProduct.product.custom_fit_price)).toLocaleString(undefined, {minimumFractionDigits: 2}) : ""} <span className="m--eur">{shouldShowPrice(CountryStore.getState()) ? symbol : ""}</span></span>
                : <span><i>{__('Standard fit')}</i> {shouldShowPrice(CountryStore.getState()) ? " + " + parseFloat(roundNumber(0)).toLocaleString(undefined, {minimumFractionDigits: 2}) : " "} <span className="m--eur">{shouldShowPrice(CountryStore.getState()) ? symbol : ""}</span></span>}
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default ProductPriceDetailed;



// WEBPACK FOOTER //
// ./src/components/ProductPriceDetailed.js